import { AxiosResponse } from 'axios';
import { useAlert, useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { SmartContract } from 'lib/types/smart-contract-types';
import {
    useMutation,
    useQuery,
    UseQueryResult,
    useQueryClient,
    UseMutationResult,
} from 'react-query';
import { commonShowAlert } from 'lib';
type SmartContractListQueryResult = UseQueryResult<
    AxiosResponse<SmartContract[], any>,
    any
>;
interface DeleteSmartContractProps {
    chainID: string;
    chainName: string;
}
const getQueryData = async (
    token: string,
    chain: string
): Promise<AxiosResponse<SmartContract[], any>> => {
    const headers = getDefaultHeaders(token);

    const response = await axiosInstance().get(
        `/graphchain/${chain}/query/smartcontracts`,
        withHeaders(headers)
    );

    return response;
};

export const useSmartContractList = (
    props: any
): SmartContractListQueryResult => {
    const { getToken } = useAuth();
    const { chain, queryProps, enabled } = props;

    return useQuery(
        `smart-contracts-${chain}`,
        async () => getQueryData(getToken(), chain),
        {
            ...queryProps,
            enabled: enabled,
        }
    );
};
const deleteSmartContract = async (
    props: DeleteSmartContractProps,
    token: string
): Promise<AxiosResponse<void, any>> => {
    const headers = getDefaultHeaders(token);
    const url = `/graphchain/${props.chainName}/${props.chainID}`;

    return axiosInstance().delete(url, withHeaders(headers));
};
export const useDeleteSmartContract = (): UseMutationResult<
    AxiosResponse<void, any>,
    Error,
    DeleteSmartContractProps,
    unknown
> => {
    const queryClient = useQueryClient();
    const { showAlert, hideAlert, showErrorDetails } = useAlert();
    const { getToken } = useAuth();

    return useMutation(
        (props: DeleteSmartContractProps) =>
            deleteSmartContract(props, getToken()),
        {
            onSuccess: () => {
                queryClient.invalidateQueries('dictionaries');
                commonShowAlert(
                    showAlert,
                    hideAlert,
                    'success',
                    'Smart Contract Deleted'
                );
            },
            onError: (error: any) => {
                const errorMessage: string =
                    error?.data?.message ?? 'Unable to delete smart contract';
                commonShowAlert(
                    showAlert,
                    hideAlert,
                    'error',
                    errorMessage,
                    JSON.stringify(error?.data ?? ''),
                    showErrorDetails
                );
            },
        }
    );
};
